import React, { useState, useEffect } from "react";
import { Formik, Form, Field } from "formik";
import { Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useQuery, useMutation, queryCache } from 'react-query'
import { injectIntl } from "react-intl";
import * as Yup from "yup";
import Alert from "react-s-alert";
import _ from "underscore";
import useAxios from "axios-hooks";

import { connect } from "react-redux";

import {postRoom, getRoom, putRoom, deleteRoom, checkRoomLive} from "./xhr";

import {InputFloatingLabel, ReactSwitch, RichText} from "../../../formik";
import { cleanObjectAndReturn } from "../../../helpers/cleanObject";
import PageLoading from "../../../components/Loading";
import axios from "axios";

const RoomForm = ({
  intl,
  match,
  history,
  embedded,
  closeModal,
  userProfile
}) => {
  const [streamingAccess, setStreamingAccess] = useState(false);
  const [roomIsActive, setRoomIsActive] = useState(false);
  const [streamingAdminPassword, setStreamingAdminPassword] = useState("");

  const { isLoading, data: room } = useQuery(['rooms', match && match.params && match.params.id ], getRoom, {
    enabled: match && match.params && match.params.id,
    onError: (err) => {
      Alert.error(intl.formatMessage({ id: err.response.data.message }))
    }
  });

  const editForm = match && match.params && match.params.id ? true : false;
  console.log("checkRoomLIveMutation room", room);

  useEffect(()=>{
    try {
      console.log("checkRoomLIveMutation room", editForm,room);
      // check room data is exsit and visioEnabled enabled
      if (editForm && room && room.visioEnabled !== undefined && room.visioEnabled === true) {
         checkRoomIsLive(room._id);
      }
    }catch (e) {
      console.log("checkRoomLIveMutation 1use", e);
    }
  },[room]);

  const [{ data, loading }, authenticateStreamingAccess] = useAxios({
    url: `${process.env.REACT_APP_API_HOST}/room/authenticate-streaming`,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    method: "POST",
    data: {
      password: streamingAdminPassword
    },
  }, {
      manual: true,
  });
  console.log("DATA room",room);
  useEffect(() => {
    if(!data) {
      return;
    }

    if(data.message === "success.authenticated") {
      setStreamingAccess(true);
    }
  }, [data]);
  const [postRoomMutation] = useMutation(postRoom, {
    onSuccess: (createdRoom) => {
      if(queryCache.getQueryData('rooms')) {
        queryCache.setQueryData('rooms', rooms => rooms.concat([createdRoom]));
      }
      Alert.success(intl.formatMessage({ id: 'room.create-success' }));
      if (embedded) {
        closeModal();
      } else {
        history.push("/rooms");
      }
    },
    onError: (err) => {
      Alert.error(intl.formatMessage({ id: err.response.data.message }))
    }
  })
  const addRoom = async (values) => {
    Alert.warning(intl.formatMessage({id: "room.creating"}));
    const {confirmPassword, ...rest } = values
    await postRoomMutation({ room: cleanObjectAndReturn(rest) })
  };

  const [putRoomMutation] = useMutation(putRoom, {
    onSuccess: (updatedRoom) => {
      if(queryCache.getQueryData('rooms')) {
        queryCache.setQueryData('rooms', rooms => rooms
          .map(room => room._id === updatedRoom._id ? updatedRoom : room)
        )
        queryCache.setQueryData(['rooms', updatedRoom._id], rooms => updatedRoom)
      }
      Alert.success(intl.formatMessage({ id: 'room.update-success' }));
      history.push("/rooms");
    },
    onError: (err) => {
      Alert.error(intl.formatMessage({ id: err.response.data.message }))
    }
  })




  const editRoom = async (values) => {
    console.log("EditROMM====>");
    Alert.warning(intl.formatMessage({id: "room.updating"}));
    await putRoomMutation({
      _id: match.params.id,
      room: cleanObjectAndReturn(_.pick(
        values,
        "name",
        "order",
        "login",
        "password",
        "streamingUrl",
        "streamingPlaybackUrl",
        "streamingWebcamUrl",
        "streamingWebcamPlaybackUrl",
        "streamingLogin",
        "streamingPassword",
        "ad",
         "visioEnabled"
      ))
    })
  };

  const ValidationSchema = editForm ?
    Yup.object().shape({
      name: Yup.string().required(),
      order: Yup.number(),
      visioEnabled:Yup.boolean,
      login: Yup.string()
        .matches(/^.[a-zA-Z0-9_]+$/, {
          message: intl.formatMessage({
            id: "error.alphanumeric",
          }),
          excludeEmptyString: true,
        })
        .min(
          6,
          intl.formatMessage({
            id: "error.atleast6",
          })
        )
        .required(),
      password: Yup.string()
        .required()
        .min(
          6,
          intl.formatMessage({
            id: "error.atleast6",
          })
        ),
    }) :
    Yup.object().shape({
      name: Yup.string().required(),
      order: Yup.number(),
      visioEnabled:Yup.boolean,
      login: Yup.string()
        .matches(/^.[a-zA-Z0-9_]+$/, {
          message: intl.formatMessage({
            id: "error.alphanumeric",
          }),
          excludeEmptyString: true,
        })
        .min(
          6,
          intl.formatMessage({
            id: "error.atleast6",
          })
        )
        .required(),
      password: Yup.string()
        .required()
        .min(
          6,
          intl.formatMessage({
            id: "error.atleast6",
          })
        ),
      confirmPassword: Yup.string().when("password", {
        is: (val) => (val && val.length > 0 ? true : false),
        then: Yup.string().oneOf(
          [Yup.ref("password")],
          intl.formatMessage({
            id: "error.passnomatch",
          })
        ),
      }),
    });


  const initialValues = editForm
    ? {
      ...room,
        ad:room?.ad ? room?.ad :"",
        visioEnabled:room?.visioEnabled ? room?.visioEnabled :false,
    }
    : {
      name: match && match.params && match.params.name ? match.params.name : "",
      order: "",
      login: "",
      password: "",
      confirmPassword: "",
      streamingUrl: "",
      streamingPlaybackUrl: "",
      streamingWebcamUrl: "",
      streamingWebcamPlaybackUrl: "",
      streamingLogin: "",
      streamingPassword: "",
      ad: "",
      visioEnabled:false
    };

  let submitButtonText = intl.formatMessage({
    id: "button.createRoom",
  });

   // call api for checking room is enabled
   function checkRoomIsLive(id) {
    try {
      axios({
        url: `${process.env.REACT_APP_API_HOST}/room/live/${id}`,
        method: 'GET',
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}` || ""
        },
      }).then(value => {
        setRoomIsActive(value.data.data.roomActiveStatus);
        console.log("checkRoomLIveMutation value", value);
      });
    } catch (e){
      console.log("checkRoomLIveMutation",e);
    }
  }

  if (editForm) {

    submitButtonText = intl.formatMessage({
      id: "button.saveRoom",
    });
  }

  if(editForm && isLoading) {
    return <PageLoading />
  }

  console.log("PageLoading");


  return (
    <Formik
      initialValues={initialValues}
      validationSchema={ValidationSchema}
      onSubmit={(values) => {
        console.log("Button Click",values);
        (editForm ? editRoom(values) : addRoom(values))
      } }
      enableReinitialize={true}
    >
      {({ values }) => {
        return (
          <Form className="add-event-form floating-label-form">
            <Row>
              <Col md={embedded ? 12 : 8}>
                <Row>
                  <Col lg={4} >
                    <Field
                      component={InputFloatingLabel}
                      type="text"
                      name="name"
                      id="name"
                      placeholder={intl.formatMessage({
                        id: "input.room.name",
                      })}
                      label={intl.formatMessage({
                        id: "input.room.name",
                      })}
                      required
                    />
                  </Col>
                  <Col lg={4}>
                    <Field
                      component={InputFloatingLabel}
                      type="number"
                      name="order"
                      id="order"
                      placeholder={intl.formatMessage({
                        id: "input.room.order",
                      })}
                      label={intl.formatMessage({
                        id: "input.room.order",
                      })}
                    />
                  </Col>
                  <Col sm={4}>
                    <Field
                      component={InputFloatingLabel}
                      type="text"
                      placeholder={intl.formatMessage({
                        id: "input.room.login",
                      })}
                      label={intl.formatMessage({
                        id: "input.room.login",
                      })}
                      name="login"
                      id="login"
                      required
                    />
                  </Col>
                  <Col lg={4}>
                    <Field
                      component={InputFloatingLabel}
                      type="text"
                      placeholder={intl.formatMessage({
                        id: "input.room.password",
                      })}
                      label={intl.formatMessage({
                        id: "input.room.password",
                      })}
                      name="password"
                      id="password"
                      required
                    />
                  </Col>


                  {!editForm && (
                    <Col lg={4}>
                      <Field
                        component={InputFloatingLabel}
                        type="text"
                        placeholder={intl.formatMessage({
                          id: "input.room.password.confirm",
                        })}
                        label={intl.formatMessage({
                          id: "input.room.password.confirm",
                        })}
                        name="confirmPassword"
                        id="confirmPassword"
                        required
                      />
                    </Col>
                  )}

                  <Col className='col show-public-views m-b-0-fg' style={{marginBottom: '25px'}}>
                    <Field
                        component={ReactSwitch}
                        offColor="#b1b1b1"
                        onColor="#f9962e"
                        disabled={roomIsActive}
                        name="visioEnabled"
                        id="visioEnabled"
                    />
                    <span className="m-l-10">Activate Visio</span>
                  </Col>
                </Row>
                <Row className="align-items-center">
                  <Col lg={12}>
                    <Field
                      component={RichText}
                      name="ad"
                      id="ad"
                      label={intl.formatMessage({
                        id: "input.room.ad",
                      })}
                      placeholder={intl.formatMessage({
                        id: "input.room.ad",
                      })}
                    />
                  </Col>
                </Row>
              </Col>
              <Col className={!embedded ? "" : "d-none"} md={4}>
                <div className="login-info-form">
                  <h5>Infos connexion logiciel</h5>
                        Choisir "Accès Organisateur" si l'ordinateur est
                        utilisé dans la salle de conférence.
                        <br />
                        E-mail Manager:{" "}
                  <b>{userProfile.email}</b>
                  <br />
                        Identifiant salle: <b>{values.login}</b>
                  <br />
                        Mot de passe salle: <b>{values.password}</b>
                </div>
                <div className="login-info-form m-t-20">
                  <Row>
                    <Col xs={12}>
                      <h5>{intl.formatMessage({ id: 'eslides.fields' })}</h5>
                    </Col>
                  </Row>
                  {
                    streamingAccess
                    ? <Row>
                      <Col md={12}>
                        <Field
                          component={InputFloatingLabel}
                          type="text"
                          placeholder={intl.formatMessage({
                            id: "input.room.streamingUrl",
                          })}
                          label={intl.formatMessage({
                            id: "input.room.streamingUrl",
                          })}
                          name="streamingUrl"
                          id="streamingUrl"
                        />
                      </Col>
                      <Col md={12}>
                        <Field
                          component={InputFloatingLabel}
                          type="text"
                          placeholder={intl.formatMessage({
                            id: "input.room.streamingPlaybackUrl",
                          })}
                          label={intl.formatMessage({
                            id: "input.room.streamingPlaybackUrl",
                          })}
                          name="streamingPlaybackUrl"
                          id="streamingPlaybackUrl"
                        />
                      </Col>
                      <Col md={12}>
                        <Field
                          component={InputFloatingLabel}
                          type="text"
                          placeholder={intl.formatMessage({
                            id: "input.room.streamingWebcamUrl",
                          })}
                          label={intl.formatMessage({
                            id: "input.room.streamingWebcamUrl",
                          })}
                          name="streamingWebcamUrl"
                          id="streamingWebcamUrl"
                        />
                      </Col>
                      <Col md={12}>
                        <Field
                          component={InputFloatingLabel}
                          type="text"
                          placeholder={intl.formatMessage({
                            id: "input.room.streamingWebcamPlaybackUrl",
                          })}
                          label={intl.formatMessage({
                            id: "input.room.streamingWebcamPlaybackUrl",
                          })}
                          name="streamingWebcamPlaybackUrl"
                          id="streamingWebcamPlaybackUrl"
                        />
                      </Col>
                      <Col md={12}>
                        <Field
                          component={InputFloatingLabel}
                          type="text"
                          placeholder={intl.formatMessage({
                            id: "input.room.streamingLogin",
                          })}
                          label={intl.formatMessage({
                            id: "input.room.streamingLogin",
                          })}
                          name="streamingLogin"
                          id="streamingLogin"
                        />
                      </Col>
                      <Col md={12}>
                        <Field
                          component={InputFloatingLabel}
                          type="text"
                          placeholder={intl.formatMessage({
                            id: "input.room.streamingPassword",
                          })}
                          label={intl.formatMessage({
                            id: "input.room.streamingPassword",
                          })}
                          name="streamingPassword"
                          id="streamingPassword"
                        />
                      </Col>
                    </Row>
                    : <Row>
                      <Col md={12}>
                        <input
                          type="password"
                          className="form-control"
                          value={streamingAdminPassword}
                          onChange={(e) => setStreamingAdminPassword(e.target.value)} />
                        <Button variant="secondary" onClick={async () => {
                          try {
                            await authenticateStreamingAccess();
                          } catch (e) {
                            Alert.error(intl.formatMessage({ id: e.response.data.message }))
                          }
                        }} disabled={loading}>Access Streaming information</Button>
                      </Col>


                    </Row>
                  }
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="form-buttons m-t-30 m-b-30 text-center">
                  {embedded ? (
                    <Button
                      onClick={() => closeModal()}
                      className="btn-black"
                    >
                      {intl.formatMessage({
                        id: "button.back",
                      })}
                    </Button>
                  ) : (
                      <Link to="/rooms">
                        <Button className="btn-black">
                          {intl.formatMessage({
                            id: "button.back",
                          })}
                        </Button>
                      </Link>
                    )}
                  <Button className="btn-custom m-l-20" type="submit">
                    {submitButtonText}
                  </Button>
                </div>
              </Col>
            </Row>
            <Row className={!embedded ? "d-none" : "d-flex"}>
              <Col md={12}>
                <Row>
                  <Col xs={12}>
                    <h5>{intl.formatMessage({ id: 'eslides.fields' })}</h5>
                  </Col>
                </Row>
                {
                  streamingAccess
                  ? <Row>
                  <Col lg={6}>
                    <Field
                      component={InputFloatingLabel}
                      type="text"
                      placeholder={intl.formatMessage({
                        id: "input.room.streamingUrl",
                      })}
                      label={intl.formatMessage({
                        id: "input.room.streamingUrl",
                      })}
                      name="streamingUrl"
                      id="streamingUrl"
                    />
                  </Col>
                  <Col lg={6}>
                    <Field
                      component={InputFloatingLabel}
                      type="text"
                      placeholder={intl.formatMessage({
                        id: "input.room.streamingPlaybackUrl",
                      })}
                      label={intl.formatMessage({
                        id: "input.room.streamingPlaybackUrl",
                      })}
                      name="streamingPlaybackUrl"
                      id="streamingPlaybackUrl"
                    />
                  </Col>
                  <Col md={6}>
                    <Field
                      component={InputFloatingLabel}
                      type="text"
                      placeholder={intl.formatMessage({
                        id: "input.room.streamingWebcamUrl",
                      })}
                      label={intl.formatMessage({
                        id: "input.room.streamingWebcamUrl",
                      })}
                      name="streamingWebcamUrl"
                      id="streamingWebcamUrl"
                    />
                  </Col>
                  <Col md={6}>
                    <Field
                      component={InputFloatingLabel}
                      type="text"
                      placeholder={intl.formatMessage({
                        id: "input.room.streamingWebcamPlaybackUrl",
                      })}
                      label={intl.formatMessage({
                        id: "input.room.streamingWebcamPlaybackUrl",
                      })}
                      name="streamingWebcamPlaybackUrl"
                      id="streamingWebcamPlaybackUrl"
                    />
                  </Col>

                  <Col lg={6}>
                    <Field
                      component={InputFloatingLabel}
                      type="text"
                      placeholder={intl.formatMessage({
                        id: "input.room.streamingLogin",
                      })}
                      label={intl.formatMessage({
                        id: "input.room.streamingLogin",
                      })}
                      name="streamingLogin"
                      id="streamingLogin"
                    />
                  </Col>
                  <Col lg={6}>
                    <Field
                      component={InputFloatingLabel}
                      type="text"
                      placeholder={intl.formatMessage({
                        id: "input.room.streamingPassword",
                      })}
                      label={intl.formatMessage({
                        id: "input.room.streamingPassword",
                      })}
                      name="streamingPassword"
                      id="streamingPassword"
                    />
                  </Col>
                </Row>
                : <Row>
                    <Col md={12}>
                      <input
                        type="password"
                        className="form-control"
                        value={streamingAdminPassword}
                        onChange={(e) => setStreamingAdminPassword(e.target.value)} />
                      <Button variant="secondary" onClick={async () => {
                        try {
                          await authenticateStreamingAccess();
                        } catch (e) {
                          Alert.error(intl.formatMessage({ id: e.response.data.message }))
                        }
                      }} disabled={loading}>Access Streaming information</Button>
                    </Col>
                  </Row>
                }
              </Col>
              <Col md={12}>
                <div className="login-info-form m-t-10">
                  <h5>Infos connexion logiciel</h5>
                    Choisir "Accès Organisateur" si l'ordinateur est
                    utilisé dans la salle de conférence.
                    <br />
                    E-mail Manager:{" "}
                  <b>{userProfile.email}</b>
                  <br />
                    Identifiant salle: <b>{values.login}</b>
                  <br />
                    Mot de passe salle: <b>{values.password}</b>
                </div>
              </Col>
            </Row>
          </Form>
        );
      }}
    </Formik>
  );
};


const mapStateToProps = (state) => ({
  userProfile: state.user.profile,
});

export default connect(mapStateToProps)(injectIntl(RoomForm));
